import React from 'react'
import PropTypes from 'prop-types'
import UnexpectedError from '../../../screens/error/UnexpectedError'
import { getLayoutElementDetails } from 'utils/screens/common'

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  }

  state = {}

  static getDerivedStateFromError(err) {
    if (err.justLogDontThrow) {
      return {}
    }
    return { hasError: true, error: err }
  }

  render() {
    if (this.state.hasError) {
      const { LayoutElement, layoutElementProps } = getLayoutElementDetails()
      return (
        <LayoutElement {...layoutElementProps}>
          <UnexpectedError error={this.state.error} />
        </LayoutElement>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary

export function noopWarn() {
  const error = new Error('undefined function called with args ' + JSON.stringify(arguments))
  error.justLogDontThrow = true
  throw error
}
